<template>
  <div class="form-group" :class="{ 'has-error': showError }">
    <div :class="{ 'col-md-4': !stacked }" v-if="label">
      <label class="control-label"
        >{{ label }}: <span v-if="required">*</span></label
      >
      <p class="help-block" v-text="helper" v-if="helper"></p>
    </div>

    <div :class="{ 'col-md-8': !stacked && label }">
      <div class="btn-group btn-group-justified w-100" role="group">
        <div class="btn-group" :key="index" v-for="(option, index) in options">
          <button
            type="button"
            class="btn btn-white btn-xs"
            :class="[isActive(option) ? 'active ' + option.highlight : '']"
            @click="select(option)"
          >
            {{ option.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: String,
    helper: String,
    showError: Boolean,
    stacked: Boolean,
    value: [String, Number, Boolean],
    required: Boolean,
    options: Array
  },

  data() {
    return {
      active: null
    };
  },

  mounted() {
    if (this.value) {
      const active = this.options.find(option => option.value == this.value);

      if (active) {
        this.active = active;
      }
    }
  },

  methods: {
    select(option) {
      this.active = option;

      this.$emit('input', option.value);
    },

    isActive(option) {
      return this.active === option;
    }
  }
};
</script>
